import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product } from '../../../models';
import { Assortment } from '../../../services/assortment.service';
import { QuickorderProduct } from '../../../services/quickorder/quickorder.service';
import { ProductDetailComponent } from '../../product-detail/product-detail.component';

@Component({
    selector: 'lib-quickorder-product-details',
    templateUrl: './quickorder-product-details.component.html',
    styleUrls: ['./quickorder-product-details.component.css'],
    standalone: false
})
export class QuickorderProductDetailsComponent extends ProductDetailComponent implements OnInit, QuickorderProduct {
  @Input()
  product: Product;

  @Output()
  updateQuantity = new EventEmitter<number>();

  @Input()
  assortment: Assortment;

  ngOnInit(): void {
    this.productId = this.product.id;
    super.ngOnInit();
  }

  addQuantity(qty) {
    this.updateQuantity.next(qty);
  }
}
